const DEFAULT_VOUCHER_SLICE_SIZE = 1000;
const DEFAULT_CATALOG_SLICE_SIZE = 10000;
const DEFAULT_PAGE_SIZE = 50;
export {
  DEFAULT_CATALOG_SLICE_SIZE,
  DEFAULT_PAGE_SIZE,
  DEFAULT_VOUCHER_SLICE_SIZE,
};
